import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Link, Stack, Typography, useTheme } from '@mui/material';

type PropTypes = {
  closeMobileDisclaimer: () => void;
  openMobileDisclaimer: boolean;
};

export const MobileDisclaimer = ({
  closeMobileDisclaimer,
  openMobileDisclaimer,
}: PropTypes) => {
  const theme = useTheme();

  return (
    <Dialog
      open={openMobileDisclaimer}
      onClose={closeMobileDisclaimer}
      sx={{
        '& .paper': {
          borderStyle: 'solid',
          borderColor: theme.palette.ranked.main,
        },
      }}
    >
      <DialogTitle>Mobile Disclaimer</DialogTitle>
      <DialogContent sx={{ width: '100%', height: '100%' }}>
        <Stack spacing={2}>
          <Typography>
            Desktop PAR is only playable on a desktop/laptop because it is best
            played using a physical keyboard.
          </Typography>
          <Typography>
            There is a lighter, mobile version available here:{' '}
            <Link target="_blank" href="https://mobile.par.live">
              mobile.par.live
            </Link>
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={closeMobileDisclaimer} fullWidth>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};
